type keyValue = { key: string; value: unknown };

export const keyValueMapper = (
  data: {
    items?: Record<string, keyValue | null>[];
  } = {}
): Record<string, unknown> =>
  Object.assign(
    {},
    ...(data.items || []).map((item) =>
      Object.entries(item)
        .filter((value): value is [string, keyValue] => value[1] !== null)
        .reduce((acc, [, value]) => {
          acc[value.key] = value.value;

          return acc;
        }, {})
    )
  );
